import React from 'react';
import { Search, Flame, Settings } from 'lucide-react';
interface HeaderProps {
  searchQuery: string;
  onSearchChange: (q: string) => void;
  onOpenAdmin: () => void;
}
export function Header({
  searchQuery,
  onSearchChange,
  onOpenAdmin
}: HeaderProps) {
  return <header className="sticky top-0 z-40 glass-panel border-b border-slate-800/80 px-6 py-4 flex items-center justify-between" data-id="element-122">
      <div className="flex items-center gap-6" data-id="element-123">
        <div className="flex items-center gap-3" data-id="element-124">
          <div className="relative flex items-center justify-center w-10 h-10 rounded-lg bg-gradient-to-br from-orange-500 to-red-600 shadow-lg shadow-orange-500/20" data-id="element-125">
            <Flame className="w-6 h-6 text-white" data-id="element-126" />
            <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-slate-900 animate-pulse-fast" data-id="element-127" />
          </div>
          <div data-id="element-128">
            <h1 className="text-2xl font-bold font-display tracking-tight text-white flex items-center gap-2" data-id="element-129">
              SHARK TANK
              <span className="px-2 py-0.5 rounded text-[10px] font-bold bg-green-500/20 text-green-400 uppercase tracking-wider border border-green-500/20" data-id="element-130">
                Live
              </span>
            </h1>
          </div>
        </div>

        <div className="h-8 w-px bg-slate-800 hidden md:block" data-id="element-131" />

        <div className="relative hidden md:block w-64 lg:w-96" data-id="element-132">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" data-id="element-133" />
          <input type="text" value={searchQuery} onChange={e => onSearchChange(e.target.value)} placeholder="Search borrowers, LOs, or states..." className="w-full bg-slate-900/50 border border-slate-700/50 rounded-full py-2 pl-10 pr-4 text-sm text-slate-200 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-orange-500/50 focus:border-orange-500/50 transition-all" data-id="element-134" />
        </div>
      </div>

      <div className="flex items-center gap-3" data-id="element-135">
        <button onClick={onOpenAdmin} title="Admin settings" aria-label="Open admin settings" className="flex items-center gap-2 px-3 py-2 rounded-lg border border-slate-700 bg-slate-900/60 text-slate-300 hover:bg-slate-800 hover:text-white hover:border-slate-600 transition-colors" data-id="element-136">
          <Settings className="w-4 h-4" data-id="element-137" />
          <span className="text-xs font-semibold uppercase tracking-wider hidden sm:inline" data-id="element-138">
            Admin
          </span>
        </button>
      </div>
    </header>;
}